import { useEffect, useState } from "react";

const LINKS = [
  { label: "Travel Tech", href: "#travel-tech" },
  { label: "Services", href: "#services" },
  { label: "AI Products", href: "#ai-products" },
  { label: "Proof", href: "#proof" },
];

export function LogoMark({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="8.4" stroke="#2B4BEA" strokeWidth="5.6" />
    </svg>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-white/[0.06] bg-ink/90 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[76px] max-w-[1160px] items-center justify-between px-6">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-2.5">
          <LogoMark className="h-[22px] w-[22px]" />
          <span className="text-[16px] font-medium tracking-[-0.01em] text-white md:text-[17px]">
            Infinity House of Technology
          </span>
        </a>
        <div className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[15px] text-white/80 transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-talk-to-us-btn"
            className="rounded-[10px] bg-brand px-5 py-2.5 text-[15px] font-medium text-white transition-all duration-300 hover:bg-brand-deep"
          >
            Talk to us
          </a>
        </div>
        <a
          href="#contact"
          data-testid="nav-talk-to-us-btn-mobile"
          className="whitespace-nowrap rounded-[10px] bg-brand px-4 py-2 text-sm font-medium text-white md:hidden"
        >
          Talk to us
        </a>
      </nav>
    </header>
  );
}
